/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import Config from "data/config";
import { useAuth } from "cms/auth/hooks/use-auth";
import { objectHasPropertyString } from "utils/empty-exists";

const useEditLink = () => {
    
    const { token } = useAuth();
    // const [link, setLink] = useState()
    // const dispatch = useDispatch()
    
    const buildUrl = (path) => {
        return Config.previewUrl + path;
    };
    const loadLink = async  (link_guid) => {
        let response;
        if (link_guid) {
            response = await SimpliCityAdminSDK.image.findOne(token, link_guid);
        }
        // setLink(response)
        return response;
    };

    const classifyLink = (_link, forceIntegration) => {
        const link = {
            guid: _link.guid,
            text: _link.text,
            url: _link.url,
            path: _link?.path,
            webpage: _link?.webpage,
            model: _link?.model,
            is_external: _link?.is_external,
            link_type: "internal",
            new_tab: _link?.new_tab,
        };
        const changeHasUrl = objectHasPropertyString(link, "url");
        const changeHasWebpage = objectHasPropertyString(link, "webpage");
        const changeUrlIsIntegration = link?.url?.startsWith( Config.Links.Integration );
        if (changeHasUrl && !changeHasWebpage && forceIntegration) {
            link.link_type = "integration";
            link.is_external = false;
        } else if (changeHasUrl && !changeHasWebpage) {
            if (link?.url?.startsWith("mailto:")) {
                link.link_type = "mailto";
                link.is_external = false;
            } else if (changeUrlIsIntegration) {
                link.link_type = "integration";
                link.is_external = false;
            } else {
                link.link_type = "external";
                link.is_external = true;
            }
        } else {
            link.is_external = false;
            link.link_type = "internal";
        }
        return link;
    };
    const validateLink = (_link)  =>  {
        let canSave = false;
        const hasWebpage = objectHasPropertyString(_link, "webpage");
        const hasText = objectHasPropertyString(_link, "text");
        const hasUrl = objectHasPropertyString(_link, "url");
        if (hasWebpage) {
            // is Internal
            if (hasText && hasUrl && hasWebpage) {
                canSave = true;
            } else {
                canSave = false;
            }
        } else {
            // is External or Mailto or Integration
            if (hasText && hasUrl) {
                canSave = true;
            } else {
                canSave = false;
            }
        }
        return canSave;
    };
    // const isExternal = link_type === 'external'
    // const isInternal = link_type === 'internal'
    // const isMailTo = link_type === 'mailto'
    // const isIntegration = link_type === 'integration'
    const isInternalLink = (link) => {
        return objectHasPropertyString(link, "webpage");
    };
    const isIntegrationLink = (link) => {
        return link?.url?.startsWith(Config.Links.Integration);
    };
    const isMailtoLink = (link) => {
        return link?.url?.startsWith(Config.Links.Integration);
    };
    const isExternalLink = (link) => {
        return link?.url?.startsWith("https:");
    };
    const isInsecureLink = (link) => {
        return link?.url?.startsWith("http:");
    };
    
    
    // const getLink = (model) => {
    //     // let link
    //     if (!link) {
    //         link = loadLink(link_guid)
    //     }
    //     return link
    // }
    
    // const fetchSeoByWebpage = async (token, webpageGuid) => {
    //     let seo
    //     try {
    //         seo = await SimpliCityAdminSDK.seo.findOneByWebpage(token, webpageGuid)
    //     } catch (error) {
    //         Logger.error(error)
    //     }
    //     try {
    //         const _metaModelSeo = await readMetaFromWebpageModel(webpage,model)
    //         setModelMeta(_metaModelSeo)
    //         if (seo !== undefined) {
    //             const metaFromSeo = await readMetaFromSEO(seo)
    //             setMeta(metaFromSeo)
    //         } else {
    //             setMeta(_metaModelSeo)
    //             seo = _metaModelSeo
    //         }
    //     } catch (error) {
    //         Logger.error(error)
    //     }
    //     dispatch(setCurrentSeo(seo))
    //     return seo
    // }
    
    return {
        classifyLink,
        validateLink,
        isInternalLink,
        isIntegrationLink,
        isMailtoLink,
        isExternalLink,
        isInsecureLink,
        loadLink,
        buildUrl,
        // link
    };
};

export { useEditLink };
